// ##############################
// // // Dashboard View styles
// #############################

import {
  primaryColor,
  successColor,
  dangerColor,
  infoColor,
  tooltip,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";

import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.jsx";

const dashboardStyle = {
  ...hoverCardStyle,
  tooltip,
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardProductTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    textAlign: "center"
  },
  cardCategory: {
    color: "#000",
    paddingTop: "20px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0"
  },
  cardProductDesciprion: {
    textAlign: "center",
    color: "#999999"
  },
  stats: {
    color: "#999999",
    fontSize: "12px",
    lineHeight: "22px",
    display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px"
    }
  },
  productStats: {
    paddingTop: "7px",
    paddingBottom: "7px",
    margin: "0"
  },
  successText: {
    color: successColor
  },
  dangerText: {
    color: dangerColor
  },
  upArrowCardCategory: {
    width: 14,
    height: 14
  },
  underChartIcons: {
    width: "17px",
    height: "17px"
  },
  price: {
    color: "inherit",
    "& h4": {
      marginBottom: "0px",
      marginTop: "0px"
    }
  },
  actionBtns: {
    '& svg': {
      top: -4,
      width: 24,
      height: 24,
    }
  },
  selectRoot: {
    color: primaryColor,
    '&>svg': {
      display: 'none',
    }
  },
  selectFormControl: {
    padding: '16px 0 0',
    '&>div': {
      '&::before, &::after': {
        display: 'none'
      },
    }
  },
  select: {
    '& svg': {
      width: 24,
      height: 16
    }
  },
  selectIcon: {
    fill: primaryColor,
    width: 40,
    height: 22,
    '@media (min-width: 425px)': {
      width: 90,
    },
    '@media (min-width: 768px)': {
      width: 120,
    },
    '@media (min-width: 1024px)': {
      width: 42,
    },
    '@media (min-width: 1200px)': {
      width: 64,
    },
  },
  rowTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pieContainer: {
    '@media (min-width: 768px)': {
      display: 'flex'
    }
  },
  info: {
    color: infoColor
  },
  rightActions: {
    width: '100%',
    '@media (min-width: 475px)': {
      width: '30%',
    },
    '@media (min-width: 768px)': {
      width: '40%',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&>div:first-child': {
      padding: 0
    }
  }
};

export default dashboardStyle;
